export default __webpack_public_path__ + "static/media/g20_yea_futurpreneur_preview.jpg";